import React from 'react';
import { ListaSucursales, ListaTerminales } from '../Comunes/Listas';
const ConsecutivosTabla = (props) => {    
    return (<>
        <div className="info" style={{ overflowX: 'auto' }}>
            <table id="tablaClientes" name="tablaClientes" className="table-striped table table-sm'">
                <thead>
                    <tr>
                        <th>Sucursal</th>
                        <th>Terminal</th>
                        <th>Siguiente</th>
                        <th>Remover</th>                        
                    </tr>
                </thead>
                <tbody>
                    {props.LosConsecutivos.map((post, index) => {
                        return post.Tipo===props.gestion? <tr key={index}>
                            <td><select id="Sucursal" name="Sucursal" className="form-group" onChange={props.ActualizarConsecutivo(index)} value={post.Sucursal}>
                            {ListaSucursales.map((option, i) => (
                                <option key={i} value={option.value}>{option.span}</option>
                            ))}</select></td>
                        
                            <td><select id="Terminal" name="Terminal" className="form-group" onChange={props.ActualizarConsecutivo(index)} value={post.Terminal}>
                            {ListaTerminales.map((option, i) => (
                                <option key={i} value={option.value}>{option.span}</option>
                            ))}</select></td>
                            <td><input id='Siguiente' type='text' className="form-group" autoComplete='off' name='Siguiente' value={post.Siguiente} onChange={props.ActualizarConsecutivo(index)}></input> </td>                            
                            <td><button onClick={() => props.EliminarConsecutivo(index)} >Eliminar</button></td>
                        </tr>:null
                    })}
                </tbody>
            </table>
        </div>

    </>)

}
export default ConsecutivosTabla;